/**
 * Gates the PostGroup UI. A leaf module, so hooks that combine it with other
 * splits can import it without loading the dialog.
 */
export const POST_GROUPS_UI_FLAG = 'geid-publish-post-groups-ui'
